import React from 'react';
import { FadeIn } from './FadeIn';
export function Impact() {
  const impacts = [{
    num: '01',
    text: 'Led multi-million dollar global risk transformation programs',
    color: '#00E5FF'
  }, {
    num: '02',
    text: 'Delivered enterprise-wide regulatory compliance initiatives',
    color: '#7C3AED'
  }, {
    num: '03',
    text: 'Built executive dashboards for board-level decision making',
    color: '#E11D74'
  }, {
    num: '04',
    text: 'Strengthened governance across global financial operations',
    color: '#C8A96A'
  }];
  return <section id="impact" className="relative py-24 md:py-32 bg-navy border-t border-white/5 overflow-hidden" data-id="element-169">
      <div className="absolute top-0 left-0 w-[600px] h-[600px] rounded-full opacity-20 blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(0,229,255,0.5) 0%, transparent 70%)'
    }} data-id="element-170"></div>
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] rounded-full opacity-20 blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(225,29,116,0.5) 0%, transparent 70%)'
    }} data-id="element-171"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-172">
        <FadeIn data-id="element-173">
          <div className="mb-16 md:mb-20" data-id="element-174">
            <div className="text-xs uppercase tracking-widest font-medium mb-6" style={{
            background: 'linear-gradient(90deg, #00E5FF, #E11D74)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }} data-id="element-175">
              Measurable Impact
            </div>
            <h3 className="text-3xl md:text-4xl lg:text-5xl font-serif text-softwhite max-w-3xl leading-tight" data-id="element-176">
              Driving outcomes that redefine{' '}
              <span style={{
              background: 'linear-gradient(135deg, #00E5FF, #E11D74)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }} data-id="element-177">
                enterprise resilience
              </span>
              .
            </h3>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-178">
          {impacts.map((impact, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-179">
              <div className="group relative h-full p-8 md:p-10 rounded-2xl bg-white/[0.03] backdrop-blur-sm border border-white/10 hover:border-white/30 transition-all duration-500 overflow-hidden" data-id="element-180">
                <div className="absolute -top-20 -right-20 w-48 h-48 rounded-full opacity-20 blur-2xl group-hover:opacity-50 transition-opacity duration-500" style={{
              background: `radial-gradient(circle, ${impact.color} 0%, transparent 70%)`
            }} data-id="element-181"></div>
                <div className="relative font-serif text-4xl md:text-5xl mb-6" style={{
              color: impact.color
            }} data-id="element-182">
                  {impact.num}
                </div>
                <h4 className="relative text-xl md:text-2xl font-serif text-softwhite leading-snug" data-id="element-183">
                  {impact.text}
                </h4>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}